import React, { useEffect, useState } from 'react';
import {
  Box, Typography, Grid, TextField, Button,
  Card, CardContent, CardActions, IconButton
} from '@mui/material';
import axios from 'axios';
import DeleteIcon from '@mui/icons-material/Delete';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

const HelpNeededManager = () => {
  const [helpList, setHelpList] = useState([]);
  const [newValue, setNewValue] = useState('');
  const token = localStorage.getItem('token');
  const apiBase = process.env.REACT_APP_API_BASE_URL;

  const fetchHelpList = () => {
    axios.get(`${apiBase}/api/admin/helpneeded`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => setHelpList(res.data))
      .catch((err) => console.error('Fetch error:', err));
  };

  useEffect(() => {
    fetchHelpList();
  }, []);

  const handleAdd = async () => {
    if (!newValue) {
      alert('Value is required.');
      return;
    }

    try {

      await axios.post(
        `${apiBase}/api/admin/helpneeded`,
        { value: newValue},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert('Help needed item added');
      setNewValue('');
      fetchHelpList();
    } catch (err) {
      console.error('Post failed:', err);
      alert('Failed to add help needed item');
    }
  };

  const handleDelete = (id) => {
    axios.delete(`${apiBase}/api/admin/helpneeded/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(fetchHelpList)
      .catch((err) => console.error('Delete error:', err));
  };

   return (
      <Box>
        <Typography variant="h6" gutterBottom>Help list for request</Typography>
        <TextField
          value={newValue}
          onChange={(e) => setNewValue(e.target.value)}
          placeholder="Enter description"
          variant="outlined"
          size="small"
          sx={{ mr: 1 }}
        />
        <Button onClick={handleAdd} variant="contained">Add</Button>
  
        <ul>
          {helpList.map((row) => (
            <li key={row.id}>
              {row.value} - {row.created_by}
              <Button
                variant="text"
                color="error"
                onClick={() => handleDelete(row.id)}
                sx={{ ml: 1 }}
              >
                Delete
              </Button>
            </li>
          ))}
        </ul>
      </Box>
    );
};

export default HelpNeededManager;
